import { render, staticRenderFns } from "./ViewRedirectedTicket.vue?vue&type=template&id=32a36b8a&scoped=true"
import script from "./ViewRedirectedTicket.vue?vue&type=script&lang=js"
export * from "./ViewRedirectedTicket.vue?vue&type=script&lang=js"
import style0 from "./ViewRedirectedTicket.vue?vue&type=style&index=0&id=32a36b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a36b8a",
  null
  
)

export default component.exports